module.exports = __webpack_public_path__ + "static/media/zipper.70317a7f.svg";